"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timeline = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
var TimelineItem_1 = require("./TimelineItem");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var TimelineContext_1 = require("./TimelineContext");
var util_1 = require("../util");
exports.Timeline = forward_ref_with_statics_1.forwardRefWithStatics(function Timeline(_a, ref) {
    var _b;
    var _c = _a.mode, mode = _c === void 0 ? "light" : _c, dashedLine = _a.dashedLine, end = _a.end, className = _a.className, children = _a.children, props = tslib_1.__rest(_a, ["mode", "dashedLine", "end", "className", "children"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-timeline", className, (_b = {},
            _b[classPrefix + "-timeline--dashline"] = dashedLine,
            _b[classPrefix + "-timeline--timeleft"] = mode === "vertical-time-left",
            _b[classPrefix + "-timeline--alternately"] = mode === "vertical-alternate",
            _b[classPrefix + "-timeline--horizontal"] = mode === "horizontal",
            _b)) }, props),
        react_1.default.Children.map(children, function (child, index) {
            if (!util_1.isChildOfType(child, TimelineItem_1.TimelineItem)) {
                return null;
            }
            return (react_1.default.createElement(TimelineContext_1.TimelineContext.Provider, { value: {
                    light: mode === "light",
                    alternately: mode === "vertical-alternate",
                    index: index,
                } }, child));
        }),
        end && react_1.default.createElement("div", { className: classPrefix + "-timeline-operate" }, end)));
}, {
    Item: TimelineItem_1.TimelineItem,
});
exports.Timeline.displayName = "Timeline";
//# sourceMappingURL=Timeline.js.map